import {
  Button,
  Divider,
  IconButton,
  Modal,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import React from "react";

const ProductDeleteDialogBox = ({ open, onClose, onSubmit, product }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Paper
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 500,
          padding: 16,
          boxShadow: 24,
          outline: "none",
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h6">Delete Product/Service</Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Stack>
        <Divider />

        <Typography variant="body1" mt={2} mb={2}>
          {`Are you sure you want to delete ${product?.name ?? ""}?`}
        </Typography>
        <Stack direction="row" sx={{ justifyContent: "flex-end" }}>
          <Button
            data-testid="delete-product"
            variant="contained"
            onClick={onSubmit}
          >
            Delete
          </Button>
        </Stack>
      </Paper>
    </Modal>
  );
};

export default ProductDeleteDialogBox;
